import { QueryKeyConfig, MutationKeyConfig } from './api-helper';

export const contactApiKeyStore = {
  createContact: (): MutationKeyConfig => ({
    mutationKey: [`CREATE_CONTACT`],
    route: `/Contact`,
    action: 'POST',
  }),
  updateContact: (): MutationKeyConfig => ({
    mutationKey: [`UPDATE_CONTACT`],
    route: `/Contact`,
    action: 'PUT',
  }),
  deleteContact: (id: number): MutationKeyConfig => ({
    mutationKey: [`DELETE_CONTACT`, id],
    route: `/Contact/${id}`,
    action: 'DELETE',
  }),
  getContacts: (): QueryKeyConfig => ({
    queryKey: [`GET_CONTACTS`],
    route: `/Contact`,
  }),
  getContactRoles: (): QueryKeyConfig => ({
    queryKey: [`GET_CONTACTS_ROLES`],
    route: `/Contact/Roles`,
  }),
  getContactMuncipalityRoles: (): QueryKeyConfig => ({
    queryKey: [`GET_CONTACTS_MUNCIPALITY_ROLES`],
    route: `/Contact/MunicipalityRoles`,
  }),
  getCustomerContacts: (id: any): QueryKeyConfig => ({
    queryKey: [`GET_CUSTOMER_CONTACTS`, id],
    route: `/Contact?CustomerID=${id}`,
    isEnabled: !!id && id > 0,
  }),
  getOfficeContacts: (id: any): QueryKeyConfig => ({
    queryKey: [`GET_CUSTOMER_CONTACTS`, id],
    route: `/Contact?OfficeID=${id}`,
  }),
  getProjectContacts: (id: any): QueryKeyConfig => ({
    queryKey: [`GET_CUSTOMER_CONTACTS`, id],
    route: `/Contact?ProjectID=${id}`,
  }),
  getUnitContacts: (id: any): QueryKeyConfig => ({
    queryKey: [`GET_UNIT_CONTACTS`, id],
    route: `/Contact?UnitID=${id}`,
  }),
  getMunicipalityContacts: (id: any, pageSrc?: string): QueryKeyConfig => ({
    queryKey: [`GET_MUNICIPALITY_CONTACTS`, id, pageSrc],
    route: `/Contact?MunicipalityID=${id}${pageSrc ? `&PageSrc=${pageSrc}` : ''}`,
    isEnabled: !!id,
  }),
  validateContactEmail: (contactID: any, contactEmail?: string): QueryKeyConfig => ({
    queryKey: [`VALIDATE_CONTACT_EMAIL`, contactID, contactEmail],
    route: `/Contact/CheckForDuplicateEmail?contactEmail=${contactEmail}&contactID=${contactID}`,
  }),
  validateContactPhone: (contactID: any, contactPhone?: any): QueryKeyConfig => ({
    queryKey: [`VALIDATE_CONTACT_PHONE`, contactID, contactPhone],
    route: `/Contact/CheckForDuplicatePhoneNumber?contactPhone=${contactPhone}&contactID=${contactID}`,
  }),
  checkContactHashMapping: (contactID: number): QueryKeyConfig => ({
    queryKey: [`CHECK_CONTACT_HASH_MAPPING`, contactID],
    route: `/Contact/HasMapping/${contactID}`,
    isEnabled: !!contactID,
  }),
  moveContact: (): MutationKeyConfig => ({
    mutationKey: [`MOVE_CONTACT`],
    route: `/Contact/MoveContacts`,
    action: 'POST',
  }),
  getMappingContacts: (contactID: any): QueryKeyConfig => ({
    queryKey: [`GET_MAPPING_CONTACTS`, contactID],
    route: `/Contact/GetMappings/${contactID}`,
    isEnabled: !!contactID && contactID > 0,
  }),
  addContactMapping: (): MutationKeyConfig => ({
    mutationKey: [`ADD_CONTACT_MAPPING`],
    route: `/Contact/AddContactMappings`,
    action: 'POST',
  }),
  deleteContactMaping: (
    contactsID: number,
    customerID: number,
    officeID: number,
    projectID: number,
    unitID: number,
    deleteHeirachy?: boolean
  ): MutationKeyConfig => ({
    mutationKey: [`DELETE_CONTACT_MAPING`, contactsID, customerID, officeID, projectID, unitID],
    route: `/Contact/Mapping?ContactsID=${contactsID}&CustomerID=${customerID}&OfficeID=${officeID}&ProjectID=${projectID}&UnitID=${unitID}&DeleteHeirachy=${!!deleteHeirachy}`,
    action: 'DELETE',
  }),
  getDuxProjects: (contactID: any): QueryKeyConfig => ({
    queryKey: [`GET_DUX_PROJECTS`, contactID],
    route: `/Contact/SynWithDuxProjects/${contactID}`,
    isEnabled: !!contactID && contactID > 0,
  }),
  addContactWithDux: (): MutationKeyConfig => ({
    mutationKey: [`ADD_CONTACT_WITH_DUX`],
    route: `/Contact/AddContactSyncWithDux`,
    action: 'POST',
  }),
  getContactHOC: (): QueryKeyConfig => ({
    queryKey: [`GET_CONTACTS_HOC`],
    route: `/Contact/AdHoc`,
  }),
  addContactSyncWithDuxForProjects: (): MutationKeyConfig => ({
    mutationKey: [`ADD_CONTACT_SYNC_WITH_DUX_FOR_PROJECT`],
    route: `/Contact/AddContactAsSyncWithDuxForProjects`,
    action: 'POST',
  }),
  getNotificationReportsStatus: (code: string, srcpage: any): QueryKeyConfig => ({
    queryKey: [`GET_NOTIFICATION_REPORTS_STATUS`, code, srcpage],
    route: `/Contact/GetNotificationReportStatus?code=${code}&srcpage=${srcpage}`,
  }),
  enableSendReport: (): MutationKeyConfig => ({
    mutationKey: ['ENABLE_CONTACT_SEND_REPORT'],
    route: '/Contact/UpdateContactSendReport',
    action: 'POST',
  }),
  enableFastField: (): MutationKeyConfig => ({
    mutationKey: ['ENABLE_CONTACT_FAST_FIELD'],
    route: '/Contact/UpdateFastFieldEmail',
    action: 'POST',
  }),
  enableSendAllReport: (): MutationKeyConfig => ({
    mutationKey: ['ENABLE_CONTACT_SEND_REPORT_ALL'],
    route: '/Contact/UpdateContactSendReportAll',
    action: 'POST',
  }),
  enableFastFieldAll: (): MutationKeyConfig => ({
    mutationKey: ['ENABLE_CONTACT_FAST_FIELD_ALL'],
    route: '/Contact/UpdateFastFieldEmailAll',
    action: 'POST',
  }),
};
